import { getData } from './request';
import type { OrganisationKind } from '@cutr/constants/organisations';

export function getOrganisationKind(
  organisationId: string,
  signal?: AbortSignal
) {
  return getData<{ kind: OrganisationKind }>(
    `/v2/organisation/${organisationId}/kind`,
    { signal }
  ).then(({ kind }) => kind);
}
